export default __webpack_public_path__ + "static/media/eQTL.d6a39019.png";